import { jsx as e, Fragment as m, jsxs as n } from "react/jsx-runtime";
import { N as a } from "./nav-actions-34ecafa5.js";
import { ThemeProvider as c } from "./components.js";
import { Route as p } from "react-router-dom";
import s from "react";
import "lucide-react";
import "./sidebar-59b82a61.js";
import "react-dom";
import "clsx";
import "./use-mobile-b816b6c7.js";
import "tailwind-merge";
import "./use-layout-167c9584.js";
function l({ router: i }) {
  const { mainContents: t } = i;
  if (t && t.length === 1) {
    const r = t[0];
    return /* @__PURE__ */ e(m, { children: s.createElement(r.content.element, {
      formID: r.id,
      params: r.content.params
    }) });
  } else
    return /* @__PURE__ */ e(m, {});
}
function R({
  routers: i,
  header: t
}) {
  return /* @__PURE__ */ n(c, { defaultTheme: "light", storageKey: "vite-ui-theme", children: [
    t || /* @__PURE__ */ n("header", { className: "flex h-10 shrink-0 items-center gap-2 border-b", children: [
      /* @__PURE__ */ e("div", { className: "flex flex-1 items-center gap-2 px-3" }),
      /* @__PURE__ */ e("div", { className: "ml-auto px-3", children: /* @__PURE__ */ e(a, {}) })
    ] }),
    /* @__PURE__ */ e("main", { children: i.map((r, o) => /* @__PURE__ */ e(p, { exact: !0, path: r.path, children: /* @__PURE__ */ e(l, { router: r }) }, o)) })
  ] });
}
export {
  R as Layout,
  l as LayoutMain
};
